import { AriaTablist } from "app/components/aria_tablist"
import { logCustomDatadogAction } from "app/scripts/shared_setup"

// "Find your solution" on the signed-out home: one story-category chip row over
// pre-rendered panels of three story cards each.
export default function StorySpotlight() {
  const root = document.querySelector<HTMLElement>(".story-spotlight")
  if (!root) return

  AriaTablist({
    tablist: root.querySelector<HTMLElement>(".story-spotlight__tabs"),
    tabs: Array.from(root.querySelectorAll<HTMLElement>(".story-spotlight__tab")),
    panels: Array.from(root.querySelectorAll<HTMLElement>(".story-spotlight__panel")),
    panelMatches: (tab, panel) => tab.dataset.category === panel.dataset.category,
    onActivate: tab => logCustomDatadogAction("story_spotlight_tab_clicked", { category_name: tab.dataset.category }),
  })
}
